import { DEFAULT_SCENE, SCENE_IDS } from "@app/protocol";
/** The widths every room and table picture is cut at. */
export const ROOM_WIDTHS = [900, 1600];
export const TABLE_WIDTHS = [700, 1400];
/** Every table picture follows one template: 1448x1086, the felt oval in the same box (ADR 0023). */
export const TABLE_ASPECT = 1448 / 1086;
export const SCENES = {
    orman: {
        id: "orman",
        room: "/scenes/orman-room",
        table: "/scenes/orman-table",
        ground: "#0e3622",
        thumb: "/scenes/orman-thumb.webp",
    },
    // Grounds are a shade under each room's mean colour. Which scenes are Club is the domain's rule
    // (`looks.isClub`, ADR 0030): Orman, Uzay, Neon.
    otel: {
        id: "otel",
        room: "/scenes/otel-room",
        table: "/scenes/otel-table",
        ground: "#4a2e17",
        thumb: "/scenes/otel-thumb.webp",
    },
    uzay: {
        id: "uzay",
        room: "/scenes/uzay-room",
        table: "/scenes/uzay-table",
        ground: "#4f7ba6",
        thumb: "/scenes/uzay-thumb.webp",
        fresh: true,
    },
    istanbul: {
        id: "istanbul",
        room: "/scenes/istanbul-room",
        table: "/scenes/istanbul-table",
        ground: "#4a2a17",
        thumb: "/scenes/istanbul-thumb.webp",
    },
    majlis: {
        id: "majlis",
        room: "/scenes/majlis-room",
        table: "/scenes/majlis-table",
        ground: "#3a1710",
        thumb: "/scenes/majlis-thumb.webp",
    },
    neon: {
        id: "neon",
        room: "/scenes/neon-room",
        table: "/scenes/neon-table",
        ground: "#2b2560",
        thumb: "/scenes/neon-thumb.webp",
        fresh: true,
    },
};
/** The scene for an id; one this client does not know yet falls back to the default (review 0012 U7). */
export function sceneOf(id) {
    const known = SCENE_IDS.includes(id ?? "");
    return SCENES[known ? id : DEFAULT_SCENE];
}
/** A `srcset` value for a picture's cuts. */
export function srcSet(stem, widths) {
    return widths.map((w) => `${stem}-${w}.webp ${w}w`).join(", ");
}
//# sourceMappingURL=scenes.js.map